"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, Flex, TimeSeriesChartSkeleton } from "@opensea/ui-kit";
export function SalesChartSkeleton(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames("h-[400px]", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TimeSeriesChartSkeleton className="size-full" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <Flex className={t1}>{t2}</Flex>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}